module.exports = __webpack_public_path__ + "img/clogo.c2287ce9.png";